import left from "../public/left.svg";
import right from "../public/right.svg";

function TableFooter({ page, setPage }) {
  const handleLeftClick = () => {
    if (page > 1) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const handleRightClick = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <div className="flex justify-between mt-4">
      <div>
        <p className="text-secondary-text">Updated every 5 minutes</p>
      </div>
      <div className="flex gap-2">
        <img
          src={left}
          alt="left"
          className={`bg-tertiary px-1 py-1 rounded-md hover:brightness-125 cursor-pointer ${
            page === 1
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : ""
          }`}
          onClick={handleLeftClick}
        />
        <span className="flex justify-center items-center border border-tertiary text-primary-text rounded-md px-2 flex-grow">
          {page}
        </span>
        <img
          src={right}
          alt="right"
          className="bg-tertiary px-1 py-1 rounded-md hover:brightness-125 cursor-pointer"
          onClick={handleRightClick}
        />
      </div>
    </div>
  );
}

export default TableFooter;
